import { useRef, useState } from "react";

import { can } from "src/Common/function";
import Active from "./Active";
import Archive from "./Archive";

function TabButton({ label, active, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        color: active ? "#0058E5" : "#7C829A",
        fontFamily: "OpenSansRegular",
        fontSize: "14px",
        fontWeight: 600,
        lineHeight: "20px",
        letterSpacing: "0.14px",
        textTransform: "capitalize",
      }}
      className="relative py-4 text-center"
    >
      {label}
      {active && <span className="absolute left-0 -bottom-px w-full h-[2px] bg-blueColor" />}
    </button>
  );
}

const Services = () => {
  const [tab, setTab] = useState("Active");
  const activeRef = useRef(null);

  const handleTabClick = (nextTab) => {
    setTab(nextTab);
  };

  return (
    <div>
      <div className="flex items-center justify-between px-5 border-b border-borderColor">
        <div className="flex items-center gap-6">
          <TabButton label="Active" active={tab === "Active"} onClick={() => handleTabClick("Active")} />
          <TabButton label="Archived" active={tab === "Archived"} onClick={() => handleTabClick("Archived")} />
        </div>
        {tab === "Active" && can("service:create") && (
          <div
            onClick={() => activeRef.current?.openAddModal()}
            className="flex items-center justify-center cursor-pointer"
          >
            <span className="text-[12px] font-[600] font-OpenSansRegular text-subTitleColor">+ Add Service Type</span>
          </div>
        )}
      </div>
      <div className="p-5">{tab === "Active" ? <Active ref={activeRef} /> : <Archive />}</div>
    </div>
  );
};

export default Services;
